// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"edc54a63","732":"2c08d4a2","762":"0756bb1c","977":"58875f78"}[chunkId] + ".chunk.js";
};